import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=5a9be1fe&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=ts&"
export * from "./detail.vue?vue&type=script&lang=ts&"
import style0 from "./detail.vue?vue&type=style&index=0&id=5a9be1fe&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9be1fe",
  null
  
)

export default component.exports